<form [formGroup]="loginForm">
    <div class="container">
        <h2 class="login">{{ "login.heading.login" | translate }}</h2>
        <div class="input-group">
            <label for="mobileNumber">{{ "login.label.phoneNo" | translate }}:</label>
            <input type="text" id="mobileNumber" formControlName="mobileNumber" maxlength="10" autocomplete="off" />
            <div
                *ngIf="loginForm.get('mobileNumber')?.errors?.['pattern'] && loginForm.get('mobileNumber')?.dirty"
                class="error-message"
            >
                {{ "login.invalidMessage.mobileNoInvalid" | translate }}
            </div>
            <div
                *ngIf="loginForm.get('mobileNumber')?.errors?.['required'] && loginForm.get('mobileNumber')?.dirty"
                class="error-message"
            >
                {{ "login.label.phoneNo" | translate }} {{ "login.invalidMessage.mandatory" | translate }}
            </div>
        </div>
        <div *ngIf="showOTPField" class="input-group">
            <label for="otp">{{ "login.label.otp" | translate }}:</label>
            <input type="text" id="otp" formControlName="otp" maxlength="6" #otpInput />
            <div
                *ngIf="
                    loginForm.get('otp')?.errors?.['pattern'] && loginForm.get('otp')?.dirty && otpSentMessage === ''
                "
                class="error-message"
            >
                {{ "login.invalidMessage.otpInvalid" | translate }}
            </div>
            <div
                *ngIf="
                    loginForm.get('otp')?.errors?.['required'] && loginForm.get('otp')?.touched && otpSentMessage === ''
                "
                class="error-message"
            >
                {{ "login.label.otp" | translate }} {{ "login.invalidMessage.mandatory" | translate }}
            </div>
            <div
                *ngIf="
                    loginForm.get('otp')?.errors?.['customError'] &&
                    loginForm.get('otp')?.dirty &&
                    otpSentMessage === ''
                "
                class="error-message"
            >
                {{ loginForm.get("otp")?.errors?.["customError"] }}
            </div>
            <div *ngIf="otpSentMessage" class="input-group">
                <div class="success-message">{{ otpSentMessage }}</div>
            </div>
        </div>
        <button
            class="save-btn"
            mat-flat-button
            (click)="showSubmitButton ? submitOTP() : sendOTP()"
            [disabled]="loginForm.invalid || isOTPButtonDisabled"
        >
            {{ (showSubmitButton ? "login.button.submitOtp" : "login.button.sendOtp") | translate }}
        </button>
        <div *ngIf="showOTPField">
            <div *ngIf="showResendLink" class="resend-link" (click)="resendOTP()">
                {{ "login.resendOTP" | translate }}
            </div>
            <div class="timer" *ngIf="showTimer">
                {{ timerDuration }}
            </div>
        </div>
    </div>
</form>
